import { Injectable } from "@angular/core";
import {
  Scene,
  Engine,
  SceneLoader,
  ArcRotateCamera,
  Vector3,
  Color4,
  MeshBuilder,
  Color3,
  EnvironmentTextureTools,
  BaseTexture,
  CubeTexture,
} from "babylonjs";
import { GradientMaterial } from "babylonjs-materials";

@Injectable({
  providedIn: "root",
})
export class ShowProductService {
  private camera;
  private originalRadius;
  private originalLowerRadiusLimit;
  private originalUpperRadiusLimit;
  private allowZoomInModal;

  public constructor() {}

  public createScene(
    canvas: HTMLCanvasElement,
    engine: Engine,
    id: any,
    embedded: boolean,
    data: any
  ): Scene {
    let product = data.filter((s) => s.id === id)[0];
    console.log(product);

    if (!product) {
      console.error("no existe ese id");
    }

    const scene = new Scene(engine);

    scene.clearColor = new Color4(
      product.configuration.scene.clearColor.r,
      product.configuration.scene.clearColor.g,
      product.configuration.scene.clearColor.b,
      product.configuration.scene.clearColor.a
    );
    scene.ambientColor = new Color3(
      product.configuration.scene.ambientColor.r,
      product.configuration.scene.ambientColor.r,
      product.configuration.scene.ambientColor.r
    );

    if (product.configuration.scene.envTexture) {
      scene.environmentTexture = new CubeTexture(
        product.configuration.scene.envTexture,
        scene
      );
    }

    SceneLoader.ImportMesh("", "assets/products/", product.babylon, scene);

    // camera
    this.camera = new ArcRotateCamera(
      "Camera",
      product.configuration.camera.alpha,
      product.configuration.camera.beta,
      product.configuration.camera.radius,
      new Vector3(
        product.configuration.camera.target.x,
        product.configuration.camera.target.y,
        product.configuration.camera.target.z
      ),
      scene
    );

    this.camera.attachControl(canvas, true);

    this.camera.minZ = 0.1;
    this.camera.maxZ = 1000;
    this.camera.panningSensibility = 0;
    this.camera.useAutoRotationBehavior =
      product.configuration.camera.useAutoRotationBehavior;

    //Me guardo los radios para cambiarlos en fullscreen
    this.originalRadius = product.configuration.camera.radius;
    this.originalLowerRadiusLimit =
      product.configuration.camera.lowerRadiusLimit;
    this.originalUpperRadiusLimit =
      product.configuration.camera.upperRadiusLimit;

    this.allowZoomInModal = product.configuration.camera.allowZoomInModal;

    if (embedded && !this.allowZoomInModal) {
      this.camera.lowerRadiusLimit = this.originalRadius;
      this.camera.upperRadiusLimit = this.originalRadius;
    } else {
      if (product.configuration.camera.lowerRadiusLimit)
        this.camera.lowerRadiusLimit =
          product.configuration.camera.lowerRadiusLimit;
      if (product.configuration.camera.upperRadiusLimit)
        this.camera.upperRadiusLimit =
          product.configuration.camera.upperRadiusLimit;
    }
    if (product.configuration.camera.lowerAlphaLimit)
      this.camera.lowerAlphaLimit =
        product.configuration.camera.lowerAlphaLimit;
    if (product.configuration.camera.upperAlphaLimit)
      this.camera.upperAlphaLimit =
        product.configuration.camera.upperAlphaLimit;

    if (product.configuration.camera.lowerBetaLimit)
      this.camera.lowerBetaLimit = product.configuration.camera.lowerBetaLimit;
    if (product.configuration.camera.upperBetaLimit)
      this.camera.upperBetaLimit = product.configuration.camera.upperBetaLimit;

    this.camera.wheelDeltaPercentage =
      product.configuration.camera.wheelDeltaPercentage;
    this.camera.pinchDeltaPercentage =
      product.configuration.camera.pinchDeltaPercentage;

    this.camera.radius = this.originalRadius;

    this.camera.fov = product.configuration.camera.fov;
    this.camera.speed = product.configuration.camera.speed;

    if (product.configuration.scene.sphere.enabled) {
      const sphere = MeshBuilder.CreateSphere(
        "sphere",
        { diameter: 50, segments: 32 },
        scene
      );

      //Para cuando no sólo tengamos una esfera
      // switch (sphere.material) {
      //   case "gradient:
      //     creas el gradient
      //     break;
      //   case "texture"
      //     creas ña texture
      //     break
      //   default:
      //     break;
      // }

      const gradientMaterial = new GradientMaterial("grad", scene);
      gradientMaterial.topColor = new Color3(0.98, 0.98, 0.98);
      gradientMaterial.bottomColor = new Color3(0.93, 0.93, 0.93);
      gradientMaterial.offset = 0.25;
      gradientMaterial.smoothness = 0.8;
      gradientMaterial.scale = 0.2;
      gradientMaterial.backFaceCulling = false;
      gradientMaterial.disableLighting = true;

      sphere.material = gradientMaterial;
      sphere.visibility = 0;
    }

    return scene;
  }

  zoom(allowZoom: boolean) {
    if (this.allowZoomInModal) {
      return;
    }
    if (allowZoom) {
      this.camera["lowerRadiusLimit"] = this.originalLowerRadiusLimit;
      this.camera["upperRadiusLimit"] = this.originalUpperRadiusLimit;
    } else {
      this.camera["lowerRadiusLimit"] = this.originalRadius;
      this.camera["upperRadiusLimit"] = this.originalRadius;
    }
  }
}
